var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[(_vm.$store.state.user.isLogining)?_c('div',{attrs:{"id":"signUp"}},[_c('div',{style:({'background':'url('+_vm.setImg('footerSignUp/register','jpg')+') center center no-repeat'})},[_c('div',[_c('p',[_vm._v("立即体验，在数据变现系统创造未来")]),_c('button',{on:{"click":_vm.signUp}},[_vm._v("立即注册")])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }